"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var React = require("react");
var Platform;
(function (Platform) {
    Platform["Instagram"] = "instagram";
    Platform["Facebook"] = "facebook";
    Platform["LinkedIn"] = "linkedin";
})(Platform = exports.Platform || (exports.Platform = {}));
var getIconClass = function (platform) {
    switch (platform) {
        case Platform.Instagram:
            return 'fab fa-instagram';
        case Platform.Facebook:
            return 'fab fa-facebook';
        case Platform.LinkedIn:
            return 'fab fa-linkedin';
        default:
            return '#';
    }
};
var getTitle = function (platform) {
    switch (platform) {
        case Platform.Instagram:
            return 'Instagram';
        case Platform.Facebook:
            return 'Facebook';
        case Platform.LinkedIn:
            return 'LinkedIn';
        default:
            return '';
    }
};
// Define the component with the props interface
var SocialMediaShareButton = function (_a) {
    var platform = _a.platform, url = _a.url;
    return (React.createElement("a", { href: url, target: "_blank", title: getTitle(platform) },
        React.createElement("span", { className: getIconClass(platform) })));
};
exports.default = SocialMediaShareButton;
